import * as Constants from "../../../constants/urls";

export const GET = (token ,filters,order,page=1) => {


    return new Promise((resolve, reject) => {
        const url = Constants.apiUrl + `/api/rfm/paginate?page=${page}`;

        fetch(url, {
            method: "post",
            body: JSON.stringify({filters}),
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json", // Set the content type to JSON

            }
        })
            .then((response) => response.json())
            .then((data) => {
                resolve(data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};
